<template lang="pug">
div
  h3 {{$t('groupPages.modules.events.title')}}
  ul.events
    li(v-for='event in module.items')
      strong.title {{event.name}}
      | &nbsp;
      | &nbsp;
      span.address {{event.city}}
        span(v-if="event.city") , 
        |  {{event.country}}
      .date {{[event.startTime * 1000, event.endTime * 1000] | fromTo}}
      div(v-if="openEditor")
        button.btn.btn-xs.btn-danger(@click="unpublish(event)") {{$t('globals.unpublish')}}  
  template(v-if='openEditor')
    .btn.btn-primary.pright(@click="showEvents") {{$t('groupPages.modules.events.publishMore')}}
    .cf
    .modal(ref="modal")
      .modal-dialog
        .modal-content
          .modal-header
            button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
            h4.modal-title {{$t('groupPages.modules.events.title')}}
          .modal-body
            template(v-if="eventsListStatus == STATUS.LOADING")
              i.fa.fa-refresh.fa-spin
            ul.events(v-else)
              li(v-for='event in eventsList')
                strong.title {{event.name}}
                | &nbsp;
                | &nbsp;
                span.address {{event.city}}
                  span(v-if="event.city") , 
                  |  {{event.country}}
                .date {{[event.startTime * 1000, event.endTime * 1000] | fromTo}}
                div(v-if="openEditor")
                  button.btn.btn-xs.btn-success(@click="publish(event)", v-if="!event.public") {{$t('globals.publish')}}   
                  button.btn.btn-xs.btn-danger(@click="unpublish(event)", v-else) {{$t('globals.unpublish')}}
              li(v-if="eventsList.length == 0")
                strong {{$t('groupPages.modules.events.nothing')}} 
            .text-center
              .btn.btn-primary.btn-xs(@click="createEvent") {{$t('groupPages.modules.events.createEvent')}}

</template>
<script type="text/javascript">
import {mapGetters} from 'vuex'
import $ from 'jquery'
import STATUS from '@/utils/status'
import {fromTo} from '@/components/shared/vue.globals'

import _ from 'lodash'

import modalsBus from '@/components/shared/ModalsBus'

export default {
  props: ['vueData', 'module', 'openEditor'],
  data () {
    return {
      STATUS
    }
  },
  computed: {
    ...mapGetters('events', [
      'eventsList',
      'eventsListStatus'
    ])
  },
  methods: {
    unpublish (event) {
      let index = _.findIndex(this.module.items, t => t.id === event.id)
      this.module.items.splice(index, 1)
      this.$store.dispatch('events/togglePublishEvent', event)
    },
    publish (event) {
      this.module.items.push(event)
      this.$store.dispatch('events/togglePublishEvent', event)
    },
    showEvents () {
      this.$store.dispatch('events/loadEventsList', {groops: [this.vueData.group]})
      $(this.$refs.modal).modal('show')
    },
    createEvent () {
      $(this.$refs.modal).modal('hide')
      modalsBus.open(modalsBus.modals.CREATE_EVENT, null, {onClose: () => {
        this.$emit('update')
      }})
    }
  },
  filters: {
    fromTo
  }
}
</script>



// WEBPACK FOOTER //
// GroupPageEvents.vue?5b579714